var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-codebox",style:({ '--rb-min': _vm.rows * 20 + 'px', '--rb-h': _vm.maxHeight ? _vm.maxHeight + 'px' : 'auto' })},[_c('codemirror',{attrs:{"value":_vm.value,"options":_vm.cmOptions},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }